import {Constants} from "../constants";

const initialState: any = {
    listRaisedAlarms: {
        pagination: [],
        data: [],
        equipments:[],
        nbr: 0,
    },
    listSolvedAlarms: {
        pagination: [],
        data: [],
        equipments:[],
        nbr: 0,
    },
    filters: {
        locationReferences: [],
        query:''
    },
};

const AlarmReducer = (
    state = initialState,
    action: any,
): any => {
    switch (action.type) {
        case Constants.SET_RAISED_ALARM_LIST:
            return {
                ...state,
                listRaisedAlarms: {
                    ...state.listRaisedAlarms,
                    pagination: {...action.payload.pagination},
                    data: {...action.payload.data},
                    equipments: action.payload.equipments
                },
            };
        case Constants.SET_SOLVED_LIST:
            return {
                ...state,
                listSolvedAlarms: {
                    ...state.listSolvedAlarms,
                    pagination: {...action.payload.pagination},
                    data: {...action.payload.data},
                    equipments: action.payload.equipments
                },
            };
        case Constants.SET_RAISED_ALARM_COUNT:
            return {
                ...state,
                listRaisedAlarms: {...state.listRaisedAlarms, nbr: action.payload},
            };
        case Constants.SET_SOLVED_COUNT:
            return {
                ...state,
                listSolvedAlarms: {...state.listSolvedAlarms, nbr: action.payload},
            };
        case Constants.SET_ALARM_LOCATION_REFERENCE_FILTER:
            return {
                ...state,
                filters: {...state.filters, locationReferences: action.payload.ids, query: action.payload.query},
            };
        default:
            return state;
    }
};

export default AlarmReducer;
